import * as React from 'react';
import * as H from 'history';
import * as ContractRepository from '../../Repository/ContractRepository';
import DesktopMenu from '../SiteMenu/DesktopMenu';
import MobileMenu from '../SiteMenu/MobileMenu';
import TreeCounter from './TreeCounter';
import FullPageLoader from '../Loader/FullPageLoader';
import { Alert, Button, Col, Layout, Row } from 'antd';
import { ConnectionState, GlobalContext } from '../../Contexts/GlobalContext';
import { Contract } from 'tree-wallet-client';
import { Navigate } from 'react-router-dom';
import { isAllowed } from '../../Service/AuthService';
import { getImpersonationData, stopImpersonation } from "../../Service/RoleService";
import { UserRoles } from '../../Repository/UserRepository';
import { LoaderContext } from '../../Contexts/LoaderContext';
import { Filter } from '../../Pages/MapPage/MapPage';

const { Header, Content, Footer } = Layout;

export interface PageProps {
  loading?: boolean;
  title?: React.ReactNode;
  history?: H.History;
  hideMenu?: boolean;
  hideCounter?: boolean;
  allowedRoles?: any;
  isPublic?: boolean;
  padded?: boolean;
  treeCount?: number;
  onlineStatus?: ConnectionState;
  trees?: any;
  filter?: Filter;
  children?: React.ReactNode
}

export interface PageState {
  loading: boolean;
}

export default class Page extends React.Component<PageProps, PageState> {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>

  constructor(props: PageProps) {
    super(props);
    this.state = {
      loading: true
    }
  }

  async componentDidMount() {
    const { contracts } = this.context;

    this.setState({ loading: true });
    if (!contracts) {
      await ContractRepository.getContractsList({
        successCallback: (response: Contract[]) => {
          this.context.contracts = response;
          return this.setState({ loading: false })
        }
      });
    }
    return this.setState({ loading: false });
  }

  render() {
    const { loading, title, hideMenu, hideCounter, allowedRoles, isPublic, padded, onlineStatus, filter } = this.props;
    const { treeCount, contract, user , counterRef, impersonating } = this.context;

    if (loading) {
      return <FullPageLoader />;
    }

    if (!isPublic && !user) {
      return <Navigate to={'/login'} />;
    }

    const isAdmin = user && user?.roles.indexOf(UserRoles.Admin.name) > -1;
    const roles = [...(contract?.roles || []), ...(user?.roles || [])];
    const isUserAllowed = isAllowed(roles, allowedRoles);
    if (
      !isAdmin
      && !isPublic
      && user
      && (!isUserAllowed || !user)
    ) {
      console.info('user not allowed', { user, userRoles: roles, allowedRoles })
      return <Navigate to={'/unauthorized'} />;
    }

    // const role = user && (getRole(user.role)?.label || '');
    const pageTitle = [
      title,
      // user ? voca.capitalize(role) : '',
      onlineStatus === ConnectionState.offline ? '(offline)' : ''
    ].join(' ');

    const impersonationData = impersonating && getImpersonationData()

    return (
      <Layout style={{ minHeight: '100vh' }}>
        {!hideMenu && (
          <LoaderContext.Consumer>
            {({ setShowLoader, setShowOfflineSync, setOfflineSyncCurrent, setOfflineSyncTotal }) => (
              <DesktopMenu 
                user={user} 
                contract={contract} 
                setShowLoader={setShowLoader} 
                setShowOfflineSync={setShowOfflineSync}
                setOfflineSyncCurrent={setOfflineSyncCurrent}
                setOfflineSyncTotal={setOfflineSyncTotal}
                filter={filter} 
              />
            )}
          </LoaderContext.Consumer>
        )}
        <Layout className="site-layout">
          {impersonating && impersonationData &&
            <Alert
              message={`Impersonating user ${impersonationData['user']}`}
              banner
              closable={false}
              action={
                <Button size="small" type="link" onClick={async () => {
                  await stopImpersonation();
                  window.location.href = '/';
                }}>
                  stop
                </Button>
              }
            />
          }
          <Header className="site-header site-layout-background" style={{ padding: '0' }}>
            <Row className={`site-page-header`}>
              <Col xs={{ span: 5 }} sm={{ span: 5 }} md={{ span: 5 }} className={'header-column'}>
                {!hideMenu && (
                  <LoaderContext.Consumer>
                    {({ setShowLoader, setShowOfflineSync, setOfflineSyncCurrent, setOfflineSyncTotal }) => (
                      <MobileMenu 
                        user={user} 
                        contract={contract} 
                        setShowLoader={setShowLoader} 
                        setShowOfflineSync={setShowOfflineSync}
                        setOfflineSyncCurrent={setOfflineSyncCurrent}
                        setOfflineSyncTotal={setOfflineSyncTotal}
                        filter={filter} 
                      />
                    )}
                  </LoaderContext.Consumer>
                )}
              </Col>
              <Col span={12} className='page-title-container header-column'><div className={'page-title'}>{pageTitle}</div></Col>
              <Col xs={{ span: 7 }} sm={{ span: 7 }} md={{ span: 7 }} className={'header-column tree-counter-container'}>
                {!hideCounter && (
                  <Row justify="end" align="middle" gutter={[8, 0]}>
                    <Col>
                      <TreeCounter key={'counter'} ref={counterRef} treeCount={parseInt(String(treeCount))} />
                    </Col>
                  </Row>
                )}
                {hideCounter && (
                  <Row justify="end" align="middle">
                    <Col>
                      {/* <GPSAccuracyIndicator /> */}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Header>
          <Content style={{ margin: '0 16px', padding: !padded ? '' : '20px' }}>
            {this.props.children}
          </Content>
          <Footer style={{ textAlign: 'center' }}/>
        </Layout>
      </Layout>
    );
  }
}